import type { Directive, DirectiveBinding } from "vue";
import { hasPerm } from "@/utils/permission";

type PermValue = string | string[];

export const permDirective: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding<PermValue>) {
    const value = binding.value;
    const modifiers = binding.modifiers;

    const has = Array.isArray(value)
      ? value.some(hasPerm)
      : hasPerm(value);

    if (has) return;

    // 显式要求隐藏
    if (modifiers.hide) {
      el.remove();
      return;
    }

    // 默认：按钮禁用
    const isButton =
      el.tagName === "BUTTON" ||
      el.classList.contains("el-button") ||
      el.closest(".el-button");

    if (isButton) {
      el.classList.add("is-disabled");
      el.setAttribute("disabled", "disabled");
      el.style.pointerEvents = "none";
    } else {
      // 非按钮默认直接隐藏（更安全）
      el.remove();
    }
  },
};
